module.exports = __webpack_public_path__ + "img/farm-chickens-infograph.11aa2e5c.svg";